export enum ButtonsTypesEnum {
    Default = 'default',
    Disabled = 'disabled',
    Secondary = 'secondary',
    Destructive = 'destructive',
    DestructiveMain = 'destructive-main',
    Tertiary = 'tertiary',
    Main = 'main'
}
